//用户权限验证—— mixin按钮级权限验证
import store from "@/store";
export const myFunc = {
    methods: {
        hasAuth(perm) {
            let perms = store.getters.GET_PERMS;
            for (let i = 0; i < perms.length; i++) {
                if (perms[i] === perm) {
                    return true;
                }
            }
            return false;
        }
    }
}